export default __webpack_public_path__ + "static/media/skeleton.a937c169.png";